/* CUSTOM */

class CartClearButton extends HTMLElement {
  #isDrawer = false;

  connectedCallback() {
    this.#isDrawer = !!this.closest('cart-drawer');
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = async (event) => {
    event.preventDefault();
    const sections = this.#isDrawer ? 'cart-drawer,cart-icon-bubble' : 'main-cart-items,cart-icon-bubble';

    try {
      await fetch(`${routes.cart_url}/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!this.#isDrawer) {
        location.reload();
        return;
      }

      const sectionData = await fetch(`${routes.cart_url}?sections=${sections}`).then((r) => r.json());

      const updateSection = (html, targetSelector, sourceSelector = targetSelector) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const target = document.querySelector(targetSelector);
        const source = doc.querySelector(sourceSelector);
        if (target && source) target.innerHTML = source.innerHTML;
      };

      updateSection(sectionData['cart-drawer'], '#CartDrawer');
      updateSection(sectionData['cart-icon-bubble'], '#cart-icon-bubble', '.shopify-section');

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('is-empty');
        cartDrawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => cartDrawer.close());
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: { item_count: 0 } });
    } catch (error) {
      console.error(error);
    }
  };
}
customElements.define('cart-clear-button', CartClearButton);


/* Terms: open link in new window + replace app alert with confirm dialog */
{
  document.addEventListener('DOMContentLoaded', () => {
    const link = document.querySelector('.terms-panikka a');
    if (link) {
      link.setAttribute('target', '_blank');
      link.textContent = link.textContent.replace('handelsbetingelserne', 'handelsbetingelserne.');
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!btn) return;

    const checkbox = document.querySelector('.pterms-checkbox');
    if (!checkbox || checkbox.checked) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (confirm('Jeg godkender hermed handelsbetingerne.')) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      btn.click();
    }
  }, true);
}

/* END CUSTOM */
